import ReviewsCapability from '.';
import Reviews from './reviews';

const { ReviewsDesktopCapability } = require('@ui-reviews/ui-reviews-capability/reviews/reviews.desktop');

export default Reviews(props => ReviewsCapability(props, ReviewsDesktopCapability, false));
